import { LogOutIcon } from '@calizahq/react-components-v2'
import React from 'react'

import { useUserContext } from '@/context'
import { useLogout } from '@/hooks/useLogout'
import { APP_TYPE } from '@/types/User'

import { DropdownChildStyled, UserChildStyled } from './UserNavigation'

type Props = {
  activeApp: APP_TYPE
}

export const Logout = ({ activeApp }: Props) => {
  const logout = useLogout()
  const { logoutUser } = useUserContext()

  const onLogoutPress = () => {
    logout.mutate({})
    logoutUser()
  }

  return (
    <UserChildStyled activeApp={activeApp} onClick={onLogoutPress}>
      <DropdownChildStyled activeApp={activeApp}>
        <div className="ml-4">
          <LogOutIcon className="text-action-input" width="24" />
        </div>
        <div className="text-action-input text-p-sm ml-2">Sign out</div>
      </DropdownChildStyled>
    </UserChildStyled>
  )
}
